import styled from "styled-components"

const HoverCardShadow = styled.a`
    background-color: #ffffff;
    border-radius: .4rem;
    text-decoration: none;
    transition: .5s ease;
    padding: 1.5rem;
    width: 100%;
    height: 100%;
    display: inline-block;
    box-shadow: 0px 0px 10px #cccccc;

    &:hover {
        box-shadow: 0px 0px 30px #cccccc;
    }
`

const HoverCardBorderLink = styled.a`
    background-color: #ffffff;
    border-radius: .4rem;
    text-decoration: none;
    transition: .5s ease;
    padding: 1.25rem;
    border: 1px solid #D4DEEF;
    display: inline-block;
    width: 100%;
    height: 100%;

    img {
        margin: auto;
    }

    &:hover {
        box-shadow: 0px 0px 30px #cccccc;
    }
`

const HoverCardBorder = styled.div`
    background-color: #ffffff;
    border-radius: .4rem;
    color: #4d4d4d;
    text-decoration: none;
    transition: .5s ease;
    height: 100%;
    padding: 1.25rem;
    border: 1px solid #D4DEEF;

    &:hover {
        box-shadow: 10px 10px 0px #d4deef;
    }

    @media screen and (max-width:600px) {
        box-shadow: 10px 10px 0px #d4deef;
    }
`


export { HoverCardShadow, HoverCardBorder, HoverCardBorderLink }
